import {
  SetInfo,
  AlphaTeamCruiser,
  Tahu,
  TheKnightBus,
  EiffelTower,
  GarbageTruck,
  HimejiCastle,
  TIEFighter,
  LloydsLegendaryDragon,
  LionKnightsCastle,
  MillenniumFalcon,
} from "./SetInfo";

export const SetInfoTotal: Map<string, SetInfo> = new Map([
  [AlphaTeamCruiser.id, AlphaTeamCruiser],
  [Tahu.id, Tahu],
  [TheKnightBus.id, TheKnightBus],
  [EiffelTower.id, EiffelTower],
  [GarbageTruck.id, GarbageTruck],
  [HimejiCastle.id, HimejiCastle],
  [TIEFighter.id, TIEFighter],
  [LloydsLegendaryDragon.id, LloydsLegendaryDragon],
  [LionKnightsCastle.id, LionKnightsCastle],
  [MillenniumFalcon.id, MillenniumFalcon],
]);
